import { Col, Row } from "react-bootstrap";
import { IComplianceInvestigationDetails } from "../../../api/IComplianceInvestigation";
import EpaCard from "../../../leap-components/EpaCard";
import EpaField from "../../../leap-components/EpaField";
import EpaFieldHtml from "../../../leap-components/EpaFieldHtml";

interface IComplianceInvestigationDetailsProps {
  complianceInvestigation: IComplianceInvestigationDetails;
}

const ComplianceInvestigationDetails = ({
  complianceInvestigation,
}: IComplianceInvestigationDetailsProps) => {
  var bodyElements = (
    <div>
      <Row>
        <Col className="col-12 col-md-6">
          <EpaField
            label={"Date Raised by EPA"}
            value={complianceInvestigation.dateraised}
          />
          <EpaField
            label={"EPA Response Level"}
            value={complianceInvestigation.responselevel}
          />
          <EpaField
            label={"Origin of Investigation"}
            value={complianceInvestigation.origin}
          />
          <EpaField
            label={"Investigation Title"}
            value={complianceInvestigation.title}
          />
        </Col>
        <Col className="col-12 col-md-6">
          <EpaField
            label={"Date Closed"}
            value={complianceInvestigation.closedate}
          />
          <EpaField
            label={"Receptors"}
            value={complianceInvestigation.receptors}
          />
          <EpaField
            label={"Issue / Theme"}
            value={complianceInvestigation.subject}
          />
        </Col>
      </Row>
      <Row>
        <Col className="col-12">
          <EpaFieldHtml
            label={"Investigation Description"}
            value={complianceInvestigation.description}
            labelClassName={"col-12 col-md-12"}
            valueClassName={"col-12 col-md-12"}
          />
        </Col>
      </Row>
    </div>
  ) as JSX.Element;

  return (
    <EpaCard
      title={"Compliance Investigation Details"}
      content={bodyElements}
    />
  );
};

export default ComplianceInvestigationDetails;
